import type { AuthObject } from '@white-label-types/auth';
import { Auth0Client } from '@auth0/auth0-spa-js';
import { datadogRum } from '@datadog/browser-rum';

export const refreshUserWrapper = async (
  auth0Client: Auth0Client | null,
  authInstance: AuthObject
) => {
  try {
    const user = await auth0Client?.getUser();
    const isAuthenticated = await auth0Client?.isAuthenticated();

    // Only overwrite auth state if the Auth0 SDK actually has session data.
    // During SSO flows (dedicated/booking portal), user data is set directly
    // on authInstance from the /userinfo API response. The SDK's in-memory
    // cache may be empty if there's no is.authenticated cookie from a prior
    // session. In that case, we must preserve the values already set on
    // authInstance rather than overwriting them with null/false.
    if (user) {
      authInstance.user = user;
    }
    if (isAuthenticated !== undefined) {
      authInstance.isAuthenticated = isAuthenticated;
    }
  } catch(error) {
    const errorContext = {
      file: 'white-label-plugin > auth.ts > refreshUserWrapper()',
      domain: authInstance.domain || '',
      user: authInstance.user || '',
      isAuthenticated: authInstance.isAuthenticated || '',
    }
    datadogRum.addError(
      new Error('Auth fetchUser:', { cause: error }),
      errorContext
    );
  }
};
